import { FormattedMessage } from 'react-intl';
import NotFoundState from '@rio-cloud/rio-uikit/NotFoundState';

interface NotFoundProps {
    onCreateDriver: () => void;
}

export const NotFound = ({ onCreateDriver }: NotFoundProps) => (
    <div className={'display-flex justify-content-center margin-top-15pct'}>
        <NotFoundState
            headline={<FormattedMessage id={'intl-msg:emptySearchResult'} />}
            message={<FormattedMessage id={'intl-msg:emptySearchResult.message'} />}
            buttons={[
                {
                    onClick: onCreateDriver,
                    text: <FormattedMessage id={'intl-msg:createDriver.addDriver.button'} />,
                },
            ]}
        />
    </div>
);
